import { render, staticRenderFns } from "./WhatsappMessageEdit.vue?vue&type=template&id=3ab3c10a"
import script from "./WhatsappMessageEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappMessageEdit.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessageEdit.vue?vue&type=style&index=0&id=3ab3c10a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports